'use client';

interface SpinnerProps {
  size?: number;
  className?: string;
}

const Spinner = ({ size = 40, className = '' }: SpinnerProps) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    borderWidth: `${Math.max(2, Math.round(size / 10))}px`,
  } as React.CSSProperties;

  return (
    <div role="status" aria-label="Loading" className={`inline-block animate-spin rounded-full border-gray-200 border-t-[#e91c23] ${className}`} style={style} />
  );
};

export default Spinner;